import React, { useEffect, useState } from 'react';
import './styles';
import Queries from '../../../../../utils/API/Queries';
import { toast } from 'react-toastify';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_INDIVIDUAL_EDITING_COMPANY_EDITORS } from './queries';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import { EDITORS_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import UIModal from '../../../../../components/UI/UIModal';
import UIOverlayCard from '../../../../../components/UI/UIOverlayCard';
import UILabeledInput from '../../../../../components/UI/UILabeledInput';
import UIIconButton from '../../../../../components/UI/UIIconButton';
import { PlusIcon } from '../../../../../assets/icons';
import { useHistory } from 'react-router-dom';
import * as EmailValidator from 'email-validator';
import { USER_ROLE_EDITOR } from '../../../../../utils/Config/Constants';
import { useApolloClient } from 'react-apollo';
import { UI_ICON_BUTTON_CANCEL_TYPE, UI_ICON_BUTTON_FILL_TYPE } from '../../../../../components/UI/UIIconButton/config';

export default function IndividualEditingCompanyEditors({ editingCompanyId }: IndividualEditingCompanyEditorsProps) {
	const [editors, setEditors] = useState<UserType[]>();
	const [editorName, setEditorName] = useState<string>('');
	const [editorEmail, setEditorEmail] = useState<string>('');
	const [editorPassword, setEditorPassword] = useState<string>('');
	const [editorPhoneNumber, setEditorPhoneNumber] = useState<string>('');
	const [showAddEditorModal, setShowAddEditorModal] = useState<boolean>(false);
	const [isCreatingEditor, setIsCreatingEditor] = useState<boolean>(false);

	const client = useApolloClient();
	const history = useHistory();

	const [getEditors, { data: editorsData }] = useLazyQuery(GET_INDIVIDUAL_EDITING_COMPANY_EDITORS, {
		variables: { query: { editingCompanyId: editingCompanyId } }
	});

	useEffect(() => {
		(async () => {
			await getEditors();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (editorsData) {
				const fetchedEditors: UserType[] = editorsData['users'];
				setEditors(fetchedEditors);
			}
		})();
	}, [editorsData]);

	if (!editors) return null;

	const createEditor = async () => {
		if (!isCreatingEditor) {
			if (editorName.trim().length === 0) {
				toast.info('Please enter an editor name!');
				return;
			} else if (!EmailValidator.validate(editorEmail.trim())) {
				toast.info('Please enter a valid email!');
				return;
			} else if (editorPhoneNumber.trim().length === 0) {
				toast.info('Please enter an editor phone number!');
				return;
			} else if (editorPassword.trim().length === 0) {
				toast.info('Please enter editors password!');
				return;
			}
			setIsCreatingEditor(true);
			const response = await client
				.mutate({
					mutation: Queries.CREATE_USER_MUTATION,
					variables: {
						role: USER_ROLE_EDITOR,
						name: editorName,
						email: editorEmail,
						phoneNumber: editorPhoneNumber,
						password: editorPassword,
						region: undefined,
						editingCompany: editingCompanyId
					}
				})
				.catch((error) => toast.error(error.message));
			if (response && response['data'].signup) {
				await getEditors();
				toast.success('Successfully created editor.');
			} else {
				toast.error('Error creating editor.');
			}
			setIsCreatingEditor(false);
			setShowAddEditorModal(false);
		}
	};

	const renderAddEditorModal = () => {
		const hideModal = () => setShowAddEditorModal(false);

		return (
			<UIModal condition={showAddEditorModal}>
				<UIOverlayCard hideModal={hideModal} padding={16} title={'Add New Editor'}>
					<UILabeledInput
						containerStyle={{ marginTop: 8 }}
						style={{ width: 360 }}
						label={'EDITOR NAME'}
						type={'text'}
						onChangeValue={setEditorName}
						value={editorName}
						placeholder={'Editor name...'}
					/>
					<UILabeledInput
						containerStyle={{ marginTop: 8 }}
						style={{ width: 360 }}
						label={'EDITOR EMAIL'}
						type={'text'}
						onChangeValue={setEditorEmail}
						value={editorEmail}
						placeholder={'Editor email...'}
					/>
					<UILabeledInput
						containerStyle={{ marginTop: 8 }}
						style={{ width: 360 }}
						label={'EDITOR PASSWORD'}
						type={'password'}
						onChangeValue={setEditorPassword}
						value={editorPassword}
						placeholder={'Editor password...'}
					/>
					<UILabeledInput
						containerStyle={{ marginTop: 8 }}
						style={{ width: 360 }}
						label={'EDITOR PHONE NUMBER'}
						type={'phoneNumber'}
						onChangeValue={setEditorPhoneNumber}
						value={editorPhoneNumber}
						placeholder={'Editor phone number...'}
					/>

					<div className='general-buttons-container'>
						<UIIconButton dark type={UI_ICON_BUTTON_FILL_TYPE} isLoading={isCreatingEditor} text={'create'} onClick={createEditor} />
						<UIIconButton dark type={UI_ICON_BUTTON_CANCEL_TYPE} text={'cancel'} onClick={hideModal} />
					</div>
				</UIOverlayCard>
			</UIModal>
		);
	};

	const renderTabComponent = () => {
		return (
			<div className='editingCompanyEditorsPin'>
				<div className='editingCompanyEditorsPin--add' onClick={() => setShowAddEditorModal(true)}>
					<img alt={'Add'} className='editingCompanyEditorsPin--add-plus' src={PlusIcon.white} />
				</div>
			</div>
		);
	};

	return (
		<div className='assignedEdits'>
			{renderTabComponent()}
			<PLTable
				type={EDITORS_TABLE_TYPE}
				emptySetText={`There are no editors found...`}
				limit={20}
				updateTable={getEditors}
				data={editors}
				onSelect={(editor) => history.push('/editor/' + editor.id)}
			/>
			{renderAddEditorModal()}
		</div>
	);
}
